(function () {
  if (window.agendaWholesaleDiscountReady) return;
  window.agendaWholesaleDiscountReady = true;

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest('#CartDrawer-Checkout, #checkout');
    if (!checkoutButton || checkoutButton.disabled) return;

    var scope = checkoutButton.closest('.drawer__inner, #MainContent, main, body') || document;
    var promo = scope.querySelector('.cart-agenda-wholesale[data-wholesale-discount-code]');
    var discountCode = promo && promo.getAttribute('data-wholesale-discount-code');

    if (!discountCode) return;

    event.preventDefault();
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var discountUrl = root + 'discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent('/checkout');
    window.location.assign(discountUrl);
  });
})();
